export default defineAppConfig({
  fbAppId: process.env.NUXT_PUBLIC_FB_APP_ID
})
